// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"33f8364a","815":"ed4e3ebc"}[chunkId] + ".chunk.js";
};